// extracted by mini-css-extract-plugin
module.exports = {"splash":"SplashScreen_splash_1dsfY","logo":"SplashScreen_logo_2M7m0"};